export default `
  _id
  theme
  size
  variant
  ctaLink
  ctaText
  type
`
